import agent, { ListData } from "../api/agent";
import { DataTableList } from "../common/interfaces/TableData";
import { Tenant } from "../models/tenant";

export type TenantStore = {
    tableData: DataTableList<Tenant>;
    loading: boolean;

    loadTenants: () => Promise<ListData<Tenant> | void>;
    deleteTenant: (id: string) => Promise<void>;
};

export const createTenantStore = (set: any, get: any): TenantStore => ({
    tableData: new DataTableList<Tenant>(),
    loading: false,

    loadTenants: async () => {
        set((s: any) => ({ tenantStore: { ...s.tenantStore, loading: true } }));
        try {
            const response = await agent.Tenants.list(new URLSearchParams());
            const res: ListData<Tenant> = Array.isArray(response)
                ? {
                    data: response,
                    totalRecords: response.length,
                    currentPage: 1,
                    pageSize: response.length,
                    orderBy: "",
                }
                : response;
            const list = res.data.reduce((acc: Map<string, Tenant>, item: Tenant) => {
                acc.set(item.id!, item);
                return acc;
            }, new Map<string, Tenant>());
            set((s: any) => ({
                tenantStore: {
                    ...s.tenantStore,
                    tableData: {
                        list,
                        currentPage: res.currentPage,
                        pageSize: res.pageSize,
                        totalRecords: res.totalRecords,
                        orderBy: res.orderBy,
                    },
                    loading: false,
                },
            }));
            return res;
        } catch (e) {
            console.error(e);
            set((s: any) => ({ tenantStore: { ...s.tenantStore, loading: false } }));
        }
    },

    deleteTenant: async (id: string) => {
        await agent.Tenants.delete(id);
        const { tableData } = get().tenantStore;
        const list = new Map(tableData.list);
        list.delete(id);
        set((s: any) => ({ tenantStore: { ...s.tenantStore, tableData: { ...tableData, list } } }));
    },
});